import { useState, useEffect, React } from 'react'
import './Sec9GrowingConfidence.css'
import Img from '../../Images/Confidence.png'
import { openDownloadPopup } from '../Section11Downloadpdf/Section11Downloadpdf.jsx';
import '../Section11Downloadpdf/Section11Downloadpdf.module.css'
import { color } from 'framer-motion';
import ShowPopupButton from "../PopupModal/ShowPopupButton";

function Sec9GrowingConfidence() {

  const [daysAgo, setDaysAgo] = useState(0);
  useEffect(() => {
    const calculateDaysAgo = () => {
      const targetDate = new Date("2024-03-27");
      const currentDate = new Date();
      const diffTime = currentDate.getTime() - targetDate.getTime();
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      setDaysAgo(diffDays);
    };

    calculateDaysAgo();

    // Update every 24 hours to keep it accurate
    const interval = setInterval(calculateDaysAgo, 24 * 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="Sec9GrowingConfidence-container container">
      <div className='Sec9GrowingConfidence-sub-container'>
            <div className='Sec9GrowingConfidence-content'>
            <h3 className="Title sec9title">Key Takeaways from the Report:</h3>

              <p className="Sec9GrowingConfidence-description text">
              In this report, you'll gain a comprehensive view of India’s thriving Mid-market GCC ecosystem and understand why these centers are scaling faster and smarter than ever before. 
              <br/>
              <br/>
              Discover how Mid-market GCCs are evolving from global process hubs to owning critical niche domains, driven by agility, innovation, and lean operating models that consistently outperform. 
              <br/>
              <br/>
              Explore what’s shaping the next wave of Mid-market GCC growth and how organizations can stay ahead of the curve. Plus, dive into success stories that showcase the rise of India's dynamic Mid-market GCCs.
              </p>
                <div className="PopupContainer">
                  <ShowPopupButton type="blue" uniqueId="section1" />
                  <div id="popup-target-section1" className="PopupTargetContainer"></div>
                </div>  
            </div>

            <div className='Sec9GrowingConfidence-right'>
              <div className='Sec9GrowingConfidence-img'>
              <a href="https://zinnov.com/centers-of-excellence/why-set-up-a-global-capability-center-gcc-blog/" target='_blank'><img src={Img} alt="WHY SET UP A GLOBAL CAPABILITY CENTER (GCC)?" className='ImageSec9' /></a>
                <div className='greybox'>
                  <div className='sidebar-blog-category-blk'><span className='category'>GCC</span><span className='dash'> - </span> <span className='read-min'>5 min read</span></div>
                  <h5><a href="https://zinnov.com/centers-of-excellence/why-set-up-a-global-capability-center-gcc-blog/" target='_blank'>WHY SET UP A GLOBAL CAPABILITY CENTER (GCC)?</a></h5>
                  <h6>Discover why it's crucial to set up a Global Capability Center (GCC) and access global talent, drive innovation, and scale your business.</h6>
                  <hr />
                  <div className='content-posted'>
                    <span className='content-posted-person'>
                      <h6><a href='https://zinnov.com/nitika-goel/' target='_blank'>Nitika Goel</a>, Sachit Bhat</h6>
                    </span>
                    <span className='content-posted-time'>
                      <h6>{daysAgo} days ago</h6>
                    </span>
                  </div>
                </div>
              </div>

              <div className='Sec9GrowingConfidence-contactus'>
                <h5>If you want to set up a GCC or an offshore captive center in India, contact us today at <a href="mailto:info@zinnov.com">info@zinnov.com</a>.</h5>
              </div>
            </div>
            
      </div>
    </div>
  )
}

export default Sec9GrowingConfidence
